/** Normalizes unknown thrown values for logging and user-facing messages (Sonar-friendly). */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  if (error == null) {
    return String(error);
  }
  if (typeof error === 'object') {
    try {
      return JSON.stringify(error);
    } catch {
      return 'Unserializable error object';
    }
  }
  return String(error);
}
